import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  max-width: 1920px;
  background-color: var(--white);
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .seguroContainer {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
  }

  .conditionsContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    max-width: 938px;
    padding: 55px 21px 0px 0px;
    margin: 0 auto;
  }

  .conditionsContainer p {
    width: 100%;
    max-width: 127px;
    text-align: center;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: var(--black);
    margin: 0px 0px 0px 0px;
  }

  .dropDownContainer {
    background-color: white;
    width: 100%;
    margin: 35px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    display: flex;
    justify-content: center;
    text-align: center;
    border-radius: 12px 12px 12px 12px;
    background-color: var(--white);
    box-shadow: 0px 5px 30px rgba(9, 30, 66, 0.15);
    transition: 0.2s all;
  }

  // Panel
  .panel {
    width: 100%;
    padding: 10px 0px 40px 0px;
  }

  // Panel Container
  .panelContainer {
    max-width: 945px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
    margin: 0 auto;
  }

  .panelPlanSeguro {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  // Panel Plan Title
  .panelPlanSeguro p:nth-child(1),
  .panelPlanSeguro p:nth-child(2),
  .panelPlanSeguro p:nth-child(3) {
    text-align: center;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    color: var(--orange);
    margin: 0px 4px 0px 4px;
  }

  .dataPanelContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 25px 0px 0px 0px;
  }

  .detallesContainer,
  .beneficiosContainer {
    width: 50%;
    max-width: 450px;

    h4 {
      font-family: Raleway;
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      margin: 0px 0px 14px 0px;
      color: var(--black);
    }

    .detalle,
    .beneficio {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      align-content: center;
      margin: 0px 0px 8px 0px;
    }

    .detalle span,
    .beneficio span {
      color: var(--orange);
      font-size: 15px;
      margin-top: 2px;
    }

    .detalle p,
    .beneficio p {
      font-family: Raleway;
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 23px;
      color: var(--black);
      margin: 0px 0px 0px 10px;
      text-align: left;
    }
  }

  .panelVigenciaButton {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
  }

  .panelVigenciaButton p:nth-child(1) {
    width: 100%;
    text-align: center;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: var(--black);
    margin: 50px 0px 0px 0px;
  }

  .panelVigenciaButton p:nth-child(2) {
    width: 100%;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    color: var(--black);
    margin: 8px 0px 0px 0px;
  }

  .panelVigenciaButton a {
    background-color: var(--orange);
    padding: 10px 20px 10px 20px;
    border: 0;
    color: var(--white);
    cursor: pointer;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    text-align: center;
    border-radius: 6px;
    transition: 0.1s all;
    margin: 21px 0px 30px 0px;
  }

  .panelVigenciaButton a:hover {
    background-color: var(--lightorange);
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    .conditionsContainer {
      justify-content: space-between;
      max-width: 795px;
      padding: 55px 15px 0px 0px;
    }

    .conditionsContainer p {
      max-width: 110px;
      font-size: 0.85em;
      padding: 0px 0px 0px 0px;
    }

    #cuotasMensuales {
      max-width: 135px;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    .conditionsContainer {
      justify-content: space-between;
      max-width: 690px;
      padding: 55px 15px 0px 0px;
    }

    .conditionsContainer p {
      max-width: 92.5px;
      font-size: 0.8em;
      padding: 0px 0px 0px 0px;
    }

    #cuotasMensuales {
      max-width: 135px;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    .dropDownContainer {
      max-width: 450px;
      min-width: 450px;
    }

    .conditionsContainer p {
      display: none;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    .dropDownContainer {
      max-width: 380px;
      min-width: 380px;
    }
  }

  // 414px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile414}) {
    .dropDownContainer {
      max-width: 330px;
      min-width: 330px;
    }
  }

  // 375px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile375}) {
    .dropDownContainer {
      max-width: 300px;
      min-width: 300px;
    }
  }

  // 350px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile350}) {
    .dropDownContainer {
      max-width: 250px;
      min-width: 250px;
    }
  }
`;

export default Container;
